import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { KeyRoundIcon, MenuIcon, XIcon } from "lucide-react";
import { book, navLinks } from "../data/book";
export function Navbar() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 border-b border-line/70 bg-ink/90 backdrop-blur" data-id="element-100" data-mp="xbzyp7u0i403">
      <nav className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-10" aria-label="Main" data-id="element-101" data-mp="sbkm4ihk10j6">
        <a href="#top" className="flex items-center gap-3" aria-label="The Mentored Founder home" data-id="element-102" data-mp="4n1fs8i2extq">
          <KeyRoundIcon className="h-6 w-6 text-gold" strokeWidth={1.75} data-id="element-103" data-mp="lzgxss28nsa" />
          <span className="hidden font-serif text-sm font-medium tracking-[0.22em] text-cream sm:inline" data-id="element-104" data-mp="ekpd96722jfl">
            THE MENTORED FOUNDER
          </span>
        </a>

        <ul className="hidden items-center gap-10 lg:flex" data-id="element-105" data-mp="1pxi1w84jurrf">
          {navLinks.map(link => <li key={link.href} data-id="element-106" data-mp="1kzzrseesq6hu">
              <a href={link.href} className="whitespace-nowrap text-[15px] text-cream/80 transition-colors duration-150 ease-out hover:text-gold-soft" data-id="element-107" data-mp="1kyopkj1016su">
                {link.label}
              </a>
            </li>)}
        </ul>

        <div className="flex items-center gap-3" data-id="element-108" data-mp="epnc7hi472zz">
          <a href={book.preorderUrl} target="_blank" rel="noopener noreferrer" className="whitespace-nowrap rounded-md bg-gold px-5 py-2.5 text-sm font-bold uppercase tracking-wider text-ink transition-colors duration-150 ease-out hover:bg-gold-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-109" data-mp="jnoxm930jeem">
            Pre-order free
          </a>
          <button type="button" className="rounded-md p-2 text-cream lg:hidden" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? "Close menu" : "Open menu"} data-id="element-110" data-mp="ul18fyeungb">
            {open ? <XIcon className="h-5 w-5" data-id="element-111" data-mp="34c36qgqpnidk" /> : <MenuIcon className="h-5 w-5" data-id="element-112" data-mp="34as3ci16gcmz" />}
          </button>
        </div>
      </nav>

      <AnimatePresence data-id="element-113" data-mp="39a4rr77p5rro">
        {open && <motion.ul initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-ink px-6 py-4 lg:hidden" data-id="element-114" data-mp="31b9qk6f3ahx8">
            {navLinks.map(link => <li key={link.href} data-id="element-115" data-mp="363b2fr8ci6mq">
                <a href={link.href} onClick={() => setOpen(false)} className="block py-3 text-cream/85 hover:text-gold-soft" data-id="element-116" data-mp="364cdvwt9wv4z">
                  {link.label}
                </a>
              </li>)}
          </motion.ul>}
      </AnimatePresence>
    </header>;
}